{
  "translation": {
    "button": {
      "ok": "D'accord",
      "back": "Retour",
      "create": "Créer",
      "logout": "Se déconnecter",
      "login": "Connexion",
      "cancel": "Annuler",
      "search": "Chercher",
      "configurations": "Configurations"
    },
    "label": {
      "configurationId": "Identifiant de configuration",
      "id": "Identifiant",
      "product": "Produit",
      "productName": "Nom du produit",
      "productId": "Identifiant du produit",
      "timeStamp": "Créé sur",
      "modifiedOn": "Modifié le",
      "validate": "Valider",
      "view": "Voir",
      "featureCode": "Code de fonction",
      "optionCode": "Code d'option",
      "productImages": "Images du produit",
      "salesText": "Texte de vente",
      "country": "Pays",
      "createdOn": "Créé sur",
      "timeZone": " UTC",
      "inActiveProduct": "Produit inactif",
      "propertyCode": "Code de propriété",
      "oldValue": "Ancienne valeur",
      "newValue": "Nouvelle valeur",
      "properties": "Propriétés",
      "options": "Options",
      "noRows": "Aucune ligne",
      "no": "Non",
      "yes": "oui"
    },
    "tooltip": {
      "validate": "Valider",
      "view": "Voir",
      "productInfo": "Information sur le produit",
      "home": "Maison",
      "valid": "Valide",
      "invalid": "Non valide",
      "added": "Ajouté",
      "deleted": "Supprimé",
      "modified": "Modifié"
    },
    "actionTypes": {
      "created": "Établie",
      "cloned": "Cloné",
      "search": "Cherché",
      "validate": "Validé"
    },
    "pageErrors": {
      "noPageFound": "Aucune page trouvée.",
      "unauthenticated": "L'utilisateur n'est pas connecté. Veuillez vous connecter. Si le problème persiste, veuillez contacter votre administrateur."
    },
    "message": {
      "logoutMessage": "L’utilisateur est déconnecté. Veuillez vous reconnecter à l’application.",
      "viewChange": "Souhaitez-vous changer la vue {{view}} ?",
      "configurationExists": "La configuration existe déjà",
      "loading": "Chargement...",
      "success": {
        "general": "Succès : ",
        "default": "Données récupérées",
        "getUser": "Détails de l'utilisateur récupérés",
        "searchConfiguration": "Configuration ajoutée",
        "getConfiguration": "Configuration récupérée"
      },
      "error": {
        "401": "Session expirée. Veuillez vous reconnecter.",
        "403": "Vous n'avez pas accès. Veuillez contacter l'administrateur.",
        "general": "Erreur : ",
        "default": "Une erreur s'est produite. Veuillez réessayer.",
        "getUser": "Impossible de charger l'utilisateur",
        "searchConfiguration": "Échec de l'ajout de la configuration",
        "getConfiguration": "Configuration",
        "getDiff": "Impossible de charger la différence",
        "invalidConfiguration": "ID de configuration invalide"
      }
    },
    "title": {
      "name": "Application de validation de configuration"
    },
    "footer": {
      "env": "Env",
      "termsAndConditions": "termes et conditions",
      "release": "R",
      "sprint": "SP",
      "build": "Construire",
      "branch": "Branche",
      "date": "Date"
    }
  }
}